import React from 'react';
import {
  ImageBackground, Pressable, StyleSheet, Text, View,
} from 'react-native';
import PropTypes from 'prop-types';
import APMStyles from '../styles';

function WorkoutTypeCard(props) {
  const {
    backgroundImg, title, onPress, selected,
  } = props;

  return (
    <Pressable
      style={styles.wrapper}
      onPress={onPress}
    >
      <View style={selected ? styles.selected : {}}>
        <View style={styles.container}>
          <ImageBackground
            source={backgroundImg}
            style={styles.backgroundImage}
          >
            <View style={styles.backgroundOverlay}>
              <Text style={styles.title}>{title.toUpperCase()}</Text>
            </View>
          </ImageBackground>
        </View>
      </View>
    </Pressable>
  );
}

WorkoutTypeCard.defaultProps = {
  backgroundImg: undefined,
  title: '',
  onPress: () => {},
  selected: false,
};

WorkoutTypeCard.propTypes = {
  backgroundImg: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  onPress: PropTypes.func,
  selected: PropTypes.bool,
};

const styles = StyleSheet.create({
  wrapper: {
    padding: 10,
  },
  container: {
    overflow: 'hidden',
  },
  backgroundImage: {
    height: 200,
    width: 250,
    borderRadius: 20,
    overflow: 'hidden',
  },
  selected: {
    shadowOpacity: 1,
    shadowRadius: 25,
    borderRadius: 20,
    shadowColor: '#2893e0',
  },
  backgroundOverlay: {
    flex: 1,
    justifyContent: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.75)',
  },
  title: {
    fontSize: APMStyles.typography.title,
    color: APMStyles.colors.text,
    textAlign: 'center',
  },
});

export default WorkoutTypeCard;
